import React from "react";
import Collapse, { Panel } from 'rc-collapse';
import Link from 'next/link';

// import appConfig from '../../appConfig';
import { BENTO, GRASSDOOR } from '../../constants/website';
import { useConfigData } from "../../Context/ConfigProvider";

const AccordionIcon = ({ isActive }) => <i className={`faq-acord-icon ${isActive ? 'icon-minus' : 'icon-plus'}`} />;

const GiftCardFaq = ({ className }) => {
  const appConfig = useConfigData();
  let host = (appConfig.APP_URL).split('.');
  const supportURl = host.length > 2 ? (appConfig.APP_URL).slice((appConfig.APP_URL).indexOf('.') + 1) : appConfig.APP_URL;

  return (
    <div className={`gift-faq ${className}`}>
      <p className="preview">FAQs</p>
      <Collapse className="faq-collapse two-rem-mb" expandIcon={AccordionIcon}>
        <Panel header="Are gift cards physical or digital? ">
          <p className="r-text">
            Gift cards bought on {appConfig.APP_URL} are digital only, both the giver and recipient will receive confirmation via email upon receipt of purchase.
          </p>
        </Panel>
        <Panel header="Do gift cards expire?">
          <p className="r-text">
            Once a gift card has been redeemed and added to your {appConfig.APP_NAME} account, the funds won’t expire.
          </p>
        </Panel>
        <Panel header={`Where can I use a ${appConfig.APP_NAME} gift card?`}>
          <p className="r-text">
            Gift card funds can be put toward any product purchased on {appConfig.APP_NAME} within {appConfig.APP_NAME}’s delivery zones. Currently, {appConfig.APP_NAME} operates in California servicing regions around Los Angeles, Riverside, Ventura County, Orange County, San Diego, San Francisco, Oakland, and San Jose. Enter the recipient's address on the <Link prefetch={false} href="/"><a href="/">{appConfig.APP_URL}</a></Link> search bar to confirm that they’ll be able to receive deliveries.
          </p>
        </Panel>
        <Panel header="Can I send a gift card to someone who lives outside of a delivery zone?">
          <p className="r-text">
            Yes, however, the gift card recipient must be within a delivery location in California in order to complete a delivery. Even if the recipient is visiting from out-of-state they must have a valid, government-issued photo ID proving they are 21 or older. We cannot accept any medical patients without a California state ID and a valid medical cannabis debit card issued in California.
          </p>
        </Panel>
        <Panel header="How can I check my gift card balance?">
          <p className="r-text">
            Once you redeem your card and add the funds from the card to your account, you can go to {" "}
            <Link prefetch={false} href={process.env.NEXT_PUBLIC_APP === GRASSDOOR ? "/myaccount" : "/paymentsettings"}>
              <a href={process.env.NEXT_PUBLIC_APP === GRASSDOOR ? "/myaccount" : "/paymentsettings"}>
                {appConfig.APP_URL}/{process.env.NEXT_PUBLIC_APP === GRASSDOOR ? "myaccount" : "paymentsettings"}
              </a>
            </Link>
            {" "}and check your balance.
          </p>
        </Panel>
        <Panel header={`Which payment methods does ${appConfig.APP_NAME} accept?`}>
          <p className="r-text">
            For gift card purchases, {appConfig.APP_NAME} accepts ACH payment solutions like {process.env.NEXT_PUBLIC_APP === GRASSDOOR ? 'Hypur and Stronghold' : 'Stronghold'}.
            For other questions contact <a href={`mailto:support@${appConfig.SUPPORT_EMAIL ? appConfig.SUPPORT_EMAIL : supportURl}`}>
              {appConfig.SUPPORT_EMAIL ? appConfig.SUPPORT_EMAIL : `support@${supportURl}`}
            </a>
          </p>
        </Panel>
        {process.env.NEXT_PUBLIC_APP === GRASSDOOR || process.env.NEXT_PUBLIC_APP === BENTO && <Panel header={`How can I redeem a Gift Card?`}>
          <p className="r-text">
            You can visit <Link prefetch={false} href={`/gift-cards-redeem`}><a href='/gift-cards-redeem'>here</a></Link> to redeem your gift card code.
          </p>
        </Panel>}
      </Collapse>
    </div>

  )

}

export default GiftCardFaq;